import styled from 'styled-components';
import { Accordion, AccordionDetails } from '@mui/material';

export const AccordionContainer = styled(Accordion)`
  width: 100%;
  background-color: transparent;
`;

export const AccordionDetailsContainer = styled(AccordionDetails)`
  width: 100%;
`;
